import _extends from "/usr/app/node_modules/@babel/runtime/helpers/esm/extends.js";
import _defineProperty from "/usr/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { Link, useLocation, useSearchParams } from "react-router-dom";
import { unbxdAnalytics } from "@/redux/actions/unbxdActions";
import { CDN_LINK, serverUrl } from "@globalConfig";
import useHelpers from "@hooks/useHelpers";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import { useCarCompareContext } from "@/_MiniApps/CarCompare/CarCompare";
import ProgressiveImage from "@componentsShared/ProgressiveImage";
import { thumbUrl } from "@/utils/imagesHelpers";
import useIsMobile from "@hooks/useIsMobile";
import { useTranslation } from "@i18n";
import { useLang } from "@/common/Contexts/LanguageContext";
import AddToFavoriteButton from "@/common/HOCs/AddToFavorite/AddToFavoriteButton";
import { twMerge } from "tailwind-merge";
import MarkitingLabel from "@/components/SearchComponent/UnbxdComponents/UnbxdCard/MarkitingLabel/MarkitingLabel";
import AddCarToCompare from "@/_MiniApps/CarCompare/Components/AddCarToCompare";
var HorizontalCarCard = function HorizontalCarCard(_ref) {
  var _post$tags;
  var post = _ref.post,
    showGrantedPopup = _ref.showGrantedPopup,
    metaData = _ref.metaData,
    isEager = _ref.isEager,
    hideFooterDeskMob = _ref.hideFooterDeskMob,
    className = _ref.className,
    wrapperClassName = _ref.wrapperClassName,
    hideFavIcon = _ref.hideFavIcon,
    rank = _ref.rank,
    page = _ref.page,
    isRecommendations = _ref.isRecommendations,
    hideGrantedLabel = _ref.hideGrantedLabel,
    hideMarkitingLabel = _ref.hideMarkitingLabel,
    hideDiscountLabel = _ref.hideDiscountLabel,
    _ref$CustomTag = _ref.CustomTag,
    CustomTag = _ref$CustomTag === void 0 ? "h2" : _ref$CustomTag,
    _ref$is_rec = _ref.is_rec,
    is_rec = _ref$is_rec === void 0 ? false : _ref$is_rec,
    _ref$isAnchor = _ref.isAnchor,
    isAnchor = _ref$isAnchor === void 0 ? false : _ref$isAnchor,
    _ref$fromHomePage = _ref.fromHomePage,
    fromHomePage = _ref$fromHomePage === void 0 ? false : _ref$fromHomePage,
    _ref$referralLocation = _ref.referralLocation,
    referralLocation = _ref$referralLocation === void 0 ? null : _ref$referralLocation,
    addCarCustomClass = _ref.addCarCustomClass,
    _ref$onClick = _ref.onClick,
    _onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    _ref$enableLinkClick = _ref.enableLinkClick,
    enableLinkClick = _ref$enableLinkClick === void 0 ? true : _ref$enableLinkClick;
  var _useTranslation = useTranslation(["web_common"]),
    t = _useTranslation.t;
  var lang = useLang();
  var location = useLocation();
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
    searchParams = _useSearchParams2[0];
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var isBrowseSearch = location.pathname.includes("/autos") || fromHomePage;
  var _useSession = useSession(),
    isLoggedIn = _useSession.isLoggedIn;
  var _useCarCompareContext = useCarCompareContext(),
    isCarIncludedToCompare = _useCarCompareContext.isCarIncluded,
    bigData = _useCarCompareContext.bigData;
  var isMobile = useIsMobile();
  if (location.pathname.includes("/deal")) {
    referralLocation = "offerpage";
  }
  var Tag = isAnchor ? "a" : Link;
  if (!enableLinkClick) {
    Tag = "div";
  }
  var LinkType = isAnchor ? "href" : "to";
  var listing_type = referralLocation ? referralLocation : searchParams.get("text") ? "search" : isBrowseSearch ? "browse" : "filter";
  var modifiedLink = createUrl(post === null || post === void 0 ? void 0 : post.product_url);
  return /*#__PURE__*/React.createElement("div", {
    className: ["relative w-full", wrapperClassName !== null && wrapperClassName !== void 0 ? wrapperClassName : undefined].join(" ")
  }, /*#__PURE__*/React.createElement(Tag, _extends({}, _defineProperty({}, LinkType, "".concat(modifiedLink).concat(isRecommendations ? "&rank=".concat(rank) : "").concat(page && rank && listing_type ? "#page_number=".concat(page, "&product_position=").concat(rank, "&listing_type=").concat(listing_type, "&logged_in=").concat(isLoggedIn) : "").concat(is_rec ? "#is_rec=1&product_position=".concat(rank, "&logged_in=").concat(isLoggedIn) : "")), {
    onClick: function onClick() {
      var params = {
        action: "click",
        query: searchParams.get("text") || "",
        pid: post.uniqueId,
        url: serverUrl + location.pathname + location.search,
        page: (metaData === null || metaData === void 0 ? void 0 : metaData.category_path) || "",
        page_type: metaData !== null && metaData !== void 0 && metaData.category_path ? "BOOLEAN" : ""
      };
      if (!isBrowseSearch || !(metaData !== null && metaData !== void 0 && metaData.category_path)) {
        // delete params.query;
        delete params.page;
        delete params.page_type;
      }
      if (isBrowseSearch && metaData !== null && metaData !== void 0 && metaData.category_path) {
        delete params.query;
      }
      unbxdAnalytics(params);
      _onClick && _onClick();
    },
    className: ["flex flex-col items-start p-3 rounded-lg border bg-white border-solid relative", isCarIncludedToCompare(post.id) ? "border-[#3C56D4] border-2" : "border-[#E9E9E9]", className ? twMerge(className) : undefined, post.campaign_id && !post.limited_quantity && !hideMarkitingLabel ? twMerge("pb-[28px]") : undefined].join(" ")
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex gap-2 w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative aspect-[4/3] m-w-[132px] h-[96px]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "rounded overflow-hidden "
  }, post.is_booked && /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-0 rounded-t opacity-[0.5993] bg-[#6f6e6e] flex items-center justify-center z-30"
  }, /*#__PURE__*/React.createElement("span", {
    className: "absolute ar:right-0 en:left-0 bottom-0 rounded-tr-lg bg-[#4a4d51] w-[74px] h-[24px] flex justify-center items-center text-white text-center text-xs font-bold"
  }, t("reserved", {
    ns: "web_search"
  }))), !post.is_booked && post !== null && post !== void 0 && post.discount && !hideDiscountLabel ? /*#__PURE__*/React.createElement("div", {
    className: "bg-[#FF6029] absolute min-w-[50px] flex items-center justify-start",
    style: {
      borderRadius: "4px 4px 0 4px"
    }
  }, /*#__PURE__*/React.createElement("img", {
    className: "absolute -top-[6px] ar:right-[5px] en:left-[5px]",
    src: lang == "ar" ? CDN_LINK + "/assets/images/discount-ar.svg" : CDN_LINK + "/assets/images/discount-en.svg",
    width: "25px",
    height: "16px",
    alt: "discount"
  }), /*#__PURE__*/React.createElement("strong", {
    className: "text-white text-[8px] font-bold leading-[12px] pt-[8px] pb-[3px] px-[5px]"
  }, post.discount, " ", /*#__PURE__*/React.createElement("span", {
    className: "text-white text-xs font-normal\n"
  }, t("sar", {
    ns: "web_sell_trade"
  })))) :
  //   <DiscountLabel text={post.discount} />
  null, /*#__PURE__*/React.createElement(ProgressiveImage, {
    imageClassName: "rounded w-full h-full object-cover",
    alt: post !== null && post !== void 0 && post.title ? post === null || post === void 0 ? void 0 : post.title : "car",
    src: thumbUrl(post.image_url || (post === null || post === void 0 ? void 0 : post.img_url), "online-v1", "0x426"),
    loading: isEager ? "eager" : "lazy",
    fetchpriority: isEager ? "high" : "low",
    progressiveSmallImage: thumbUrl(post === null || post === void 0 ? void 0 : post.image_url, "online-v1", isMobile ? "0x99" : "0x154"),
    width: 132,
    height: 96
  }))), /*#__PURE__*/React.createElement("div", {
    className: "w-full flex flex-col justify-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-start justify-between"
  }, /*#__PURE__*/React.createElement(CustomTag, {
    className: "text-[#484848] text-[13px] font-bold leading-[24px]  overflow-hidden text-ellipsis max-w-[145px] line-clamp-2 h-[48px]"
  }, post === null || post === void 0 ? void 0 : post.title)), /*#__PURE__*/React.createElement("div", {
    className: "flex items-end justify-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: ""
  }, parseInt(post.monthly_installment) > 0 && /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-start"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-[#697A8F] text-[8px] font-semibold leading-[12px]"
  }, t("installment_starts", {
    ns: "web_search"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2 text-[#3C56D4] text-xs font-bold leading-4"
  }, /*#__PURE__*/React.createElement("strong", null, post.monthly_installment), /*#__PURE__*/React.createElement("span", {
    className: "text-[#3C56D4] text-xs font-normal leading-4"
  }, t("sar", {
    ns: "web_search"
  }), " /", " ", t("monthly", {
    ns: "web_search"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-end gap-[2px]"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-[#697A8F] text-[8px] font-semibold leading-[12px]"
  }, t("vat_inclusive", {
    ns: "web_search"
  })), /*#__PURE__*/React.createElement("div", {
    className: "text-[#00B362] text-sm font-bold leading-4"
  }, /*#__PURE__*/React.createElement("strong", null, post.sellingprice), " ", /*#__PURE__*/React.createElement("span", {
    className: "text-[#00B362] text-sm font-normal leading-4"
  }, t("sar", {
    ns: "web_search"
  }))), post.drop_price && /*#__PURE__*/React.createElement("div", {
    className: "text-[#697A8F] text-xs font-bold leading-4 line-through"
  }, /*#__PURE__*/React.createElement("strong", null, post.drop_price), " ", /*#__PURE__*/React.createElement("span", {
    className: "text-[#697A8F] text-xs font-normal leading-4"
  }, t("sar", {
    ns: "web_search"
  }))))))), /*#__PURE__*/React.createElement("div", {
    className: "w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between border-t border-[#E9E9E9] mt-2 pt-2 border-solid"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex gap-[4px]"
  }, !hideFooterDeskMob && (post === null || post === void 0 ? void 0 : (_post$tags = post.tags) === null || _post$tags === void 0 ? void 0 : _post$tags.map(function (tag, i) {
    var style = {
      backgroundColor: tag.color ? tag.color : "#f1f6fc"
    };
    return /*#__PURE__*/React.createElement("span", {
      style: style,
      className: "flex p-[2px] px-2 justify-center items-center rounded text-[#4B5A6B] text-[10px] font-medium leading-[16px]",
      key: i
    }, tag.text);
  }))), post.condition_id == "0" && !hideGrantedLabel ? /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-[2px] bg-[#eff6ff] w-fit p-1 rounded cursor-pointer min-h-[20px]",
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
      showGrantedPopup();
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/garnteed.svg",
    width: 10,
    height: 10,
    alt: "garnteed",
    "aria-label": "garnteed"
  }), /*#__PURE__*/React.createElement("strong", {
    className: "text-[8px] leading-[16px] text-[#154f9c]"
  }, t("inspected_guaranteed", {
    ns: "web_search"
  }))) : null)), /*#__PURE__*/React.createElement("div", {
    className: "w-full",
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, !(bigData !== null && bigData !== void 0 && bigData.showComparison) && /*#__PURE__*/React.createElement("div", {
    className: "mt-2"
  }), (bigData === null || bigData === void 0 ? void 0 : bigData.showComparison) && /*#__PURE__*/React.createElement("div", {
    className: "border-t border-[#E9E9E9] mt-2 pt-2 border-solid"
  }, /*#__PURE__*/React.createElement(AddCarToCompare, {
    car: post,
    className: twMerge(["!px-0 !pt-[5px]", post.campaign_id && !post.limited_quantity && !hideMarkitingLabel ? "!pb-[5px]" : "!pb-[0px]", "[border:none!important]", addCarCustomClass].join(" "))
  }))), post.campaign_id && !post.limited_quantity && !hideMarkitingLabel ? /*#__PURE__*/React.createElement(MarkitingLabel, {
    HorizontalCarCardDesignClasses: "absolute bottom-0 left-0 w-full rounded-bl-lg rounded-br-lg p-2 px-3 text-white text-[10px] font-medium leading-[12px] h-[28px]",
    campaign: {
      id: post.campaign_id,
      txt: post.campaign_txt,
      bg_color: post.campaign_bg_color_hex
    }
  }) : null), !hideFavIcon && /*#__PURE__*/React.createElement(AddToFavoriteButton, {
    postId: +(post.uniqueId || post.id),
    className: "absolute top-[8px] en:right-[5px] ar:left-[5px] z-9",
    g4_data: post.g4_data_layer
  }));
};
export default HorizontalCarCard;